import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  Empty,
  Popconfirm,
  Button,
  Modal,
  Form,
  Col,
  notification,
  message,
  Drawer,
  Input,
  Row,
  Tooltip,
  Tabs,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  MailOutlined,
  MailFilled,
  DownloadOutlined,
  BarsOutlined,
  FilePdfOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { odata } from "../Filters/Helper";
import CashAccountAddForm from "../Forms/CashAccountAddForm";
import config from "../../util/ApiforContext";
import { RowHelper } from "../../util/TableHelper";
import ManualAccountUpdate from "../Forms/ManualAccountUpdate";
import ManualAccountAdd from "../Forms/ManualAccountAdd";
import RequestHandler from "../../util/RequestHandler";
import ManualAccountPageTableFilter from "../Filters/ManualAccountPageTableFilter";
import Iframe from "react-iframe";
import CreditCardTransactionAddForm from "../Forms/CreditCardTransactionAddForm";
import CreditCardTransactionUpdateForm from "../Forms/CreditCardTransactionUpdateForm";
import CreditCardTransactionTableFilter from "../Filters/CreditCardTransactionTableFilter";
import moment from "moment";

const ManualAccountPage = () => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 13,
    },
  };
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
    activeTab: "0",
  });
  const [addCashAccountVisibility, setAddCashAccountVisibility] =
    useState(false);
  const [order, setOrder] = useState("");
  const [accountIdForModalReceipt, setAccountIdForModalReceipt] = useState("");
  const [EmailVisible, setEmailVisible] = useState(true);
  const [Email, setEmail] = useState(localStorage.getItem("email"));
  const [isModalVisibleReceipt, setIsModalVisible] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [updateFormData, setUpdateFormData] = useState();
  const [visible, setVisible] = useState(false);
  const [visibleUpdate, setVisibleUpdate] = useState(false);
  const [tabKeyValue, setTabKeyValue] = useState("0");
  const [creditCardTransactionAddVisible, setCreditCardTransactionAddVisible] =
    useState(false);
  const [
    creditCardTransactionUpdateVisible,
    setCreditCardTransactionUpdateVisible,
  ] = useState(false);
  const prevActiveTabKeyRef = useRef("");

  const [IsUsePosTransactionCheck, setIsUsePosTransactionCheck] = useState(false);

  const [posBankInfo, setPosBankInfo] = useState([]);

  useEffect(() => getTableData(), [order, tableDataQueryOptions]);
  useEffect(() => {
    prevActiveTabKeyRef.current = tabKeyValue;
  }, [tabKeyValue]);

  useEffect(() => {
    getTenantParameter();
  },[])

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter, activeTab } = tableDataQueryOptions;

    const conditions = [];

    if (filter && prevActiveTabKeyRef.current === tabKeyValue) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }

    if (tabKeyValue === "0") {
      RequestHandler.get(
        `/ManualAccountTransaction?$count=true${query}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        if (Array.isArray(response.value)) {
          setTableData({
            data: response.value,
            total: response["@odata.count"],
            loading: false,
          });
        }
      });
    } else {
      RequestHandler.get(
        `/CreditCardTransaction?$count=true${query}&$skip=${skip}&$top=${take}&$orderby=AddDate desc`
      ).then((response) => {
        if (Array.isArray(response.value)) {
          setTableData({
            data: response.value,
            total: response["@odata.count"],
            loading: false,
          });
        }
      });
    }
  };

  const handleOkReceipt = () => {
    setPdfUrl("");
    setIsModalVisible(false);
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(orderBy);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onChangeEmail = (values) => {
    setEmail(values.target.value);
  };
  const alertSuccess = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Pdf indirme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };
  const setDownloadExcel = () => {
    const hide = message.loading("Pdf indiriliyor...", 0);
    window.open(
      `${
        config.apiUrl
      }/Pdf/DownloadPdfReceiptColumnsWithDoc?id=${accountIdForModalReceipt}&isDownload=true&t=${RequestHandler.getToken()}`
    );
    setIsModalVisible(true);
    alertSuccess("success");
    hide();
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const sendMail = () => {
    setLoading(true);
    if (Email.length > 0) {
      RequestHandler.post(
        `/AccountTransaction/ReceiptSendMail`,
        { Email: Email, Path: pdfUrl, ScreenOption: Screen.screen },
        false,
        { rawResponse: true }
      ).then((res) => {
        if (res.data === "NotFound") {
          mailNotFound("error");
          setLoading(false);
        } else if (res.status == 204 || res.status == 200) {
          setLoading(false);
          setIsModalVisible(false);
          sendSuccessMail("success");
        }
      });
    } else {
      mailEmptyError("error");
      setLoading(false);
    }
  };

  const handleCancelReceipt = () => {
    setPdfUrl("");
    setIsModalVisible(false);
  };
  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const showDrawerUpdate = (id) => {
    RequestHandler.get(`/ManualAccountTransaction/GetById/${id}`).then(
      (response) => {
        setUpdateFormData(response);
        setVisibleUpdate(true);
      }
    );
  };

  const showCreditCardTransactionDrawerUpdate = (id) => {
    RequestHandler.get(`/CreditCardTransaction/GetById/${id}`).then(
      (response) => {
        setUpdateFormData(response);
        setCreditCardTransactionUpdateVisible(true);
      }
    );
  };

  const mailEmptyError = (type) => {
    notification[type]({
      message: "HATA",
      description: "Mail adresi girilmedi.",
      duration: 2,
    });
  };

  const mailNotFound = (type) => {
    notification[type]({
      message: "HATA",
      description: "Mail adresi kayıtlı değil.",
      duration: 2,
    });
  };
  const onFinishUpdateReceipt = (values) => {};

  const onFinishFailedUpdateReceipt = (values) => {};
  const sendSuccessMail = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Mail gönderme işlemi başarılı.",
      duration: 2,
    });
  };

  const onAddCashAccountSuccess = () => {
    getTableData();
    setAddCashAccountVisibility(false);
  };
  const onAddSuccess = () => {
    getTableData();
    setVisible(false);
    setCreditCardTransactionAddVisible(false);
  };

  const onUpdateSuccess = () => {
    getTableData();
    setVisibleUpdate(false);
    setCreditCardTransactionUpdateVisible(false);
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/ManualAccountTransaction?id=${id}`).then(
      (response) => {
        if (response.success) {
          getTableData();
        }
      }
    );
  };
  const creditCardTransactionHandleOnClickDelete = (id) => {
    RequestHandler.delete(`/CreditCardTransaction/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const showModalReceipt = (value) => {
    setAccountIdForModalReceipt(value);
    setEmailVisible(true);

    RequestHandler.get(
      `/Pdf/DownloadPdfReceiptColumnsWithDoc?id=${value}&isDownload=false`,
      undefined,
      { rawResponse: true }
    ).then((response) => {
      if (response.status == 200) {
        setPdfUrl(response.data);
        setIsModalVisible(true);
      }
    });
  };
  const columns = [
    {
      title: "Cari Adı",
      dataIndex: "firmName",
      width: "10%",
      render: (text) => {
        if (!text) return;

        return (
          <Tooltip placement="topLeft" title={text}>
            {text.length < 15 ? text : text.substring(0, 15) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Cari Kodu",
      dataIndex: "firmCode",
      width: "10%",
    },
    {
      title: "Döviz",
      dataIndex: "currency",
      width: "10%",
    },
    {
      title: "Tutar",
      dataIndex: "amountString",
      align: "left",
      render: (text) => <div style={{ width: "170%" }}>{text}</div>,
    },
    {
      title: "İşlem Türü",
      dataIndex: "transactionProcessType",
      width: "10%",
      render: (text) => <div>{text === "Odeme" ? "Ödeme" : text}</div>,
    },
    {
      title: "İşlem Tipi",
      dataIndex: "manualTransactionTypeName",
      width: "10%",
    },
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      key: "transactionDateValue",
      sorter: true,
      render: (text) => <div>{text.substring(0, 10)}</div>,
    },

    {
      title: "Açıklama",
      dataIndex: "description",
      align: "left",
      render: (text) => {
        if (!text) return;

        return (
          <Tooltip placement="topLeft" title={text}>
            {text.length < 50 ? text : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Dekont",
      dataIndex: "id",
      width: "1%",
      align: "right",
      render: (data) => {
        return (
          <a
            style={{ color: "black", fontSize: "130%" }}
            onClick={() => showModalReceipt(data)}
          >
            {" "}
            <FilePdfOutlined />
          </a>
        );
      },
    },
    {
      title: "Güncelle",
      dataIndex: "id",
      width: "1%",
      align: "right",
      render: (data) => (
        <a
          onClick={() => showDrawerUpdate(data)}
          style={{ color: "orange", fontSize: "130%" }}
        >
          <EditOutlined />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      render: (data) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(data)}
        >
          <a style={{ color: "red", fontSize: "130%" }}>
            <DeleteOutlined />
          </a>
        </Popconfirm>
      ),
    },
  ];

  const detailColumns = [
    {
      title: "Açıklama",
      dataIndex: "description",
    },
  ];

  const creditCardColumns = [
    {
      title: "Cari Adı",
      dataIndex: "firmName",
      width: "10%",
      render: (text) => {
        if (!text) return;

        return (
          <Tooltip placement="topLeft" title={text}>
            {text.length < 15 ? text : text.substring(0, 15) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Cari Kodu",
      dataIndex: "firmBranchNumber",
      width: "10%",
    },
    {
      title: "Döviz",
      dataIndex: "currencyCode",
      width: "10%",
    },
    {
      title: "Tutar",
      dataIndex: "amountString",
      align: "left",
      render: (text) => <div style={{ width: "170%" }}>{text}</div>,
    },
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      key: "transactionDate",
      render: (text) => <div>{moment(text).format("DD-MM-YYYY")}</div>,
    },

    {
      title: "Kredi Kartı No",
      dataIndex: "cardNumber",
      align: "left",
    },

    {
      title: "Onay Kodu",
      dataIndex: "authCode",
      align: "left",
    },
    {
      title: "Güncelle",
      dataIndex: "id",
      width: "1%",
      align: "right",
      render: (data) => (
        <a
          onClick={() => showCreditCardTransactionDrawerUpdate(data)}
          style={{ color: "orange", fontSize: "130%" }}
        >
          <EditOutlined />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      render: (data) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => creditCardTransactionHandleOnClickDelete(data)}
        >
          <a style={{ color: "red", fontSize: "130%" }}>
            <DeleteOutlined />
          </a>
        </Popconfirm>
      ),
    },
  ];

  const creditCardDetailColumns = [
    {
      title: "Açıklama",
      dataIndex: "description",
    },
    {
      title: "Satış Elemanı",
      dataIndex: "salesmanCode",
    },

    {
      title: "Taksit",
      dataIndex: "installmentType",
      render: (value) => {
        {
          return value == 0 ? "Tek Çekim" : "Taksitli İşlem";
        }
      },
    },
  ];

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
    setTabKeyValue(tabKey);
  };

  
  const getTenantParameter = () => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        setIsUsePosTransactionCheck(response.isPosTransactionCheckForCreditCardTransaction);

        if(response.isPosTransactionCheckForCreditCardTransaction) {
          RequestHandler.get("/PosBankInfo").then((response) => {
            setPosBankInfo(response.value);
          });
        }
      } 
    });
  }

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={14}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> KASA İŞLEMLERİ
          </p>
        </Col>
        <Col
          xs={24}
          md={12}
          lg={10}
          style={{ display: "inline-flex", justifyContent: "right" }}
        >
          <Button
            type="primary"
            onClick={() => {
              setCreditCardTransactionAddVisible(true);
            }}
            style={{ marginBottom: 0 }}
            icon={<PlusOutlined />}
          >
            Kredi Kartı İşlemi Ekle
          </Button>
          <Button
            type="primary"
            onClick={() => {
              setAddCashAccountVisibility(true);
            }}
            style={{ marginBottom: 0 }}
            icon={<PlusOutlined />}
          >
            Kasa Hesabı Ekle
          </Button>
          <Button type="primary" onClick={() => setVisible(true)}>
            <PlusOutlined /> Elden İşlem Ekle
          </Button>
        </Col>
      </Row>

      {tabKeyValue === "0" && (
        <ManualAccountPageTableFilter
          onClearFilter={onClearTableFilter}
          onFinishFilter={onFinishTableFilter}
          style={{ marginTop: 12, marginBottom: 12 }}
        />
      )}

      {tabKeyValue === "1" && (
        <CreditCardTransactionTableFilter
          onClearFilter={onClearTableFilter}
          onFinishFilter={onFinishTableFilter}
          style={{ marginTop: 12, marginBottom: 12 }}
        />
      )}

      <Tabs
        defaultActiveKey={tableDataQueryOptions.activeTab}
        onChange={onTabChange}
      >
        <Tabs.TabPane tab="Elden İşlemler" key="0" />
        <Tabs.TabPane tab="Kredi Kartı İşlemleri" key="1" />
      </Tabs>

      <Row id="tableArea">
        <Col span={24}>
          {tabKeyValue === "0" && (
            <Table
              columns={columns}
              expandable={{
                expandedRowRender: (row) =>
                  RowHelper.renderRowDetail({
                    data: row,
                    columns: detailColumns,
                  }),
              }}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              style={{ overflowX: "auto", maxHeight: "100%" }}
              rowKey="id"
              filterable={true}
              size="small"
              sortable={true}
              pageable={true}
              onChange={paging}
              pagination={{
                defaultPageSize: tableDataQueryOptions.take,
                pageSizeOptions: ["15", "25", "50", "100"],
                total: tableData.total,
                current: tableDataQueryOptions.current,
              }}
              dataSource={tableData.data}
              loading={tableData.loading}
            />
          )}

          {tabKeyValue === "1" && (
            <Table
              columns={creditCardColumns}
              expandable={{
                expandedRowRender: (row) =>
                  RowHelper.renderRowDetail({
                    data: row,
                    columns: creditCardDetailColumns,
                  }),
              }}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              style={{ overflowX: "auto", maxHeight: "100%" }}
              rowKey="id"
              filterable={true}
              size="small"
              sortable={true}
              pageable={true}
              onChange={paging}
              pagination={{
                defaultPageSize: tableDataQueryOptions.take,
                pageSizeOptions: ["15", "25", "50", "100"],
                total: tableData.total,
                current: tableDataQueryOptions.current,
              }}
              dataSource={tableData.data}
              loading={tableData.loading}
            />
          )}
        </Col>
      </Row>

      <Drawer
        title="Elden İşlem Ekle"
        onClose={() => setVisible(false)}
        visible={visible}
        bodyStyle={{ padding: 24 }}
        width={500}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <ManualAccountAdd onSuccess={onAddSuccess} />
      </Drawer>
      <Drawer
        id="addCashAccount"
        title="Kasa Hesabı Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddCashAccountVisibility(false)}
        visible={addCashAccountVisibility}
      >
        <CashAccountAddForm onSuccess={onAddCashAccountSuccess} />
      </Drawer>
      <Drawer
        title="Elden İşlem Güncelle"
        onClose={() => setVisibleUpdate(false)}
        visible={visibleUpdate}
        bodyStyle={{ padding: 24 }}
        width={500}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <ManualAccountUpdate
          data={updateFormData}
          onSuccess={onUpdateSuccess}
        />
      </Drawer>

      <Modal
        title="Dekont"
        width={1000}
        style={{ height: 1000 }}
        visible={isModalVisibleReceipt}
        onOk={handleOkReceipt}
        onCancel={handleCancelReceipt}
        footer={null}
      >
        <Form
          {...layout}
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinishUpdateReceipt}
          onFinishFailed={onFinishFailedUpdateReceipt}
          fields={[{ name: "Email", value: Email }]}
        >
          <Row>
            <Col span={20}></Col>
            <Col span={2}>
              {EmailVisible ? (
                <MailOutlined
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setEmailVisible(!EmailVisible)}
                />
              ) : (
                <MailFilled
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setEmailVisible(!EmailVisible)}
                />
              )}
            </Col>
            <Col span={2}>
              <DownloadOutlined
                style={{ fontSize: 20, marginBottom: 20 }}
                onClick={() => setDownloadExcel()}
              />
            </Col>
          </Row>
          <Row hidden={EmailVisible}>
            <Col span={18}>
              <Form.Item
                label="Mail Adresi"
                name="Email"
                style={{ width: "100%" }}
              >
                <Input value={Email} onChange={onChangeEmail} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item>
                <Button
                  type="primary"
                  onClick={() => sendMail()}
                  loading={loading}
                >
                  Gönder
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Iframe
          url={pdfUrl}
          width="100%"
          height="1000px"
          id="myId"
          className="myClassname"
          display="initial"
          position="relative"
        />
      </Modal>

      <Drawer
        title="Kredi Kartı İşlemi Ekle"
        onClose={() => setCreditCardTransactionAddVisible(false)}
        visible={creditCardTransactionAddVisible}
        bodyStyle={{ padding: 24 }}
        width={500}
        footer={<div style={{ textAlign: "right" }}></div>}
        destroyOnClose={true}
      >
        <CreditCardTransactionAddForm onSuccess={onAddSuccess} isUsePosTransactionCheck={IsUsePosTransactionCheck} posBankInfo={posBankInfo}/>
      </Drawer>
      <Drawer
        title="Kredi Kartı İşlemi Güncelle"
        onClose={() => setCreditCardTransactionUpdateVisible(false)}
        visible={creditCardTransactionUpdateVisible}
        bodyStyle={{ padding: 24 }}
        width={500}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <CreditCardTransactionUpdateForm
          data={updateFormData}
          onSuccess={onUpdateSuccess}
          isUsePosTransactionCheck={IsUsePosTransactionCheck} 
          posBankInfo={posBankInfo}
        />
      </Drawer>
    </>
  );
};

export default ManualAccountPage;
